/**
 * 从 document.forms[0] 内 .ztree 读取 zTree 勾选节点（Mixpanel「Search Change」埋点分支）。
 * 任一环节缺失时返回 []，避免 null/undefined 上调用 getCheckedNodes（L1）。
 *
 * @param {*} $ - jQuery 实例，需已挂载 $.fn.zTree
 * @param {Document} doc
 * @returns {Array}
 */
export function getSearchFormZTreeCheckedNodes ($, doc) {
  if (!$ || !$.fn || !$.fn.zTree || typeof $.fn.zTree.getZTreeObj !== 'function') {
    return []
  }
  const form = doc.forms[0]
  if (!form) return []
  const ztreeElement = form.querySelector('.ztree')
  if (!ztreeElement) return []
  const ztreeId = ztreeElement.getAttribute('id')
  if (!ztreeId) return []
  const ztreeObj = $.fn.zTree.getZTreeObj(ztreeId)
  if (!ztreeObj || typeof ztreeObj.getCheckedNodes !== 'function') return []
  const nodes = ztreeObj.getCheckedNodes()
  return Array.isArray(nodes) ? nodes : []
}
